import React from 'react';
import classnames from 'classnames';
import './index.less';

export interface IABSSubTitleProps {
  className?: string;
  title?: string;
}
 
export interface IABSSubTitleState {
  
}
 
class ABSSubTitle extends React.Component<IABSSubTitleProps, IABSSubTitleState> {
  render() { 
    const { className, title } = this.props;
    const clazs = classnames('abs-sub-title', className);
    return ( 
      <div className={clazs}>{title}</div> 
    );
  }
}
 
export default ABSSubTitle;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSSubTitle/index.tsx